exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#projects{display:flex;align-content:flex-start;justify-content:center;padding:40px 0}#projects .app-projects-column{width:300px;margin:0 10px}#projects .app-projects-column.app-projects-info{color:#242424;padding-right:20px}#projects .app-projects-column.app-projects-info h2{font-size:3em;margin:10px 0}#projects .app-projects-column.app-projects-info p{font-size:1.2em;line-height:1.5}#projects .app-projects-column .app-project-card{margin:20px 0}#projects .app-projects-container{display:flex}@media (max-width:1080px){#projects{flex-direction:column;align-items:center}#projects .app-projects-info{text-align:center}}@media (max-width:640px){.app-projects-column{margin-top:10px!important}.app-projects-column .app-project-card:last-child{margin-bottom:0!important}.app-projects-container{flex-direction:column}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-033325e3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Home/PanelProjects.vue
// module id = 45
// module chunks = 0